export default __webpack_public_path__ + "static/media/teams.e47917f8.svg";